var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Objects",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-5, .cls-4 {\n        fill: #00427c;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #f8f8f8;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 1280,
    height: 720
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 54.7,
    y1: 534.51,
    x2: 390.48,
    y2: 717.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 658.13,
    y1: -145.07,
    x2: 993.9,
    y2: 38.12
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "559.98 -229.34 1423.89 241.97 1423.89 -229.34 559.98 -229.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "802.24 986.2 -231.42 422.28 -231.42 986.2 802.24 986.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1073.08,
    y1: 78.52,
    x2: 1408.85,
    y2: 261.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1034.71,
    y1: 619.48,
    x2: 1127.75,
    y2: 670.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1078.48,
    y1: 679.91,
    x2: 1171.52,
    y2: 730.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1216.91,
    y1: 678.86,
    x2: 1265.02,
    y2: 705.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 198.53,
    y1: 73.17,
    x2: 246.65,
    y2: 99.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 115.89,
    y1: 27.24,
    x2: 164,
    y2: 53.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -17.84,
    y1: 148.94,
    x2: 153.81,
    y2: 242.59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.97,426l-52.7,27.37c-5.91,3.07-8.21,10.34-5.14,16.25l.68,1.3,4.34,8.35,52.64,101.36,4.34,8.35,.68,1.3c3.07,5.91,10.34,8.21,16.25,5.14l52.7-27.37c5.91-3.07,8.21-10.34,5.14-16.25l-.68-1.3-4.34-8.35-52.64-101.36-4.34-8.35-.68-1.3c-3.07-5.91-10.34-8.21-16.25-5.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 194.2,
    y: 423.15,
    width: 83.49,
    height: 169.48,
    rx: 12.05,
    ry: 12.05,
    transform: "translate(-207.54 165.91) rotate(-27.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.76,
    cy: 431.67,
    r: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.85,
    y: 438.95,
    width: 31.75,
    height: 7.35,
    rx: 3.67,
    ry: 3.67,
    transform: "translate(-181.42 142.33) rotate(-27.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.7,
    y: 434.8,
    width: 4.7,
    height: 9.17,
    transform: "translate(-174.37 164.71) rotate(-27.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 254.5,
    y: 447.88,
    width: 4.7,
    height: 9.17,
    transform: "translate(-179.64 169.31) rotate(-27.45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.63,646.76l-8.82-1.51c-8.1-1.39-13.54-9.08-12.15-17.18l1.03-6.02c.65-3.77,3.39-6.84,7.06-7.9l3.74-1.09c6.57-1.91,13.61-1.36,19.8,1.54l5.78,2.7c4.89,2.29,7.07,8.04,4.94,13l-2.74,6.35c-3.13,7.27-10.84,11.45-18.64,10.11Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 293.69,
    y1: 622.04,
    x2: 285.41,
    y2: 620.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.11,655.76l8.82,1.51c8.1,1.39,15.79-4.05,17.18-12.15l1.03-6.02c.65-3.77-.91-7.58-4.02-9.81l-3.16-2.27c-5.56-3.99-12.37-5.82-19.18-5.15l-6.35,.62c-5.37,.53-9.35,5.23-8.99,10.61l.46,6.9c.53,7.9,6.4,14.41,14.2,15.75Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 393.15,
    y1: 639.11,
    x2: 401.43,
    y2: 640.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.51,623.89s10.01-6.65,16.74,2.87"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.21,633l.08,1.19c11.68,.32,22.42-2.28,29.53-7.1-2.73-1.59-5.72-2.67-8.81-3.2-2.31-.4-4.68-.49-7.04-.25l-6.35,.62c-4.45,.44-7.7,4.27-7.4,8.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.87,630.8l.52-1.2c1.77-4.11-.02-8.81-4.07-10.71h0s-5.78-2.71-5.78-2.71c-5.24-2.46-11.13-3.11-16.76-1.9,5.27,6.97,14.76,12.99,26.08,16.51Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 77.74,
    cy: 452.95,
    r: 50.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.19,447.65h-18.02c-2.57-17.82-17.9-31.52-36.43-31.52-20.33,0-36.82,16.48-36.82,36.82s16.48,36.82,36.82,36.82c18.54,0,33.86-13.7,36.43-31.52h18.02c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 77.74,
    cy: 452.95,
    r: 29.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.35,432.78c-5-4.64-11.58-7.27-18.62-7.27-15.13,0-27.44,12.31-27.44,27.44,0,7.03,2.63,13.62,7.27,18.62-.93-2.97-1.4-6.07-1.4-9.22,0-17.08,13.89-30.97,30.97-30.97,3.15,0,6.25,.48,9.22,1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M960.78,185.25h250.16v139.55c0,7.45-6.05,13.5-13.5,13.5h-223.16c-7.45,0-13.5-6.05-13.5-13.5V185.25h0Z",
    transform: "translate(235.57 -462.53) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1232.02 250.05 1008.88 136.98 1009.8 109.71 1253.46 233.17 1232.02 250.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1011.76,158.55h245.9c7.52,0,13.63,6.11,13.63,13.63h-273.15c0-7.52,6.11-13.63,13.63-13.63Z",
    transform: "translate(197.26 -495.02) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1017.87 131.66 1018.14 123.81 1237.17 234.79 1230.99 239.65 1017.87 131.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1017.87 131.66 1018.14 123.81 1237.17 234.79 1230.99 239.65 1017.87 131.66"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1031.23,
    y: 291.19,
    width: 64.16,
    height: 30.19,
    transform: "translate(253.25 -447.53) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1032.14,
    y1: 296.84,
    x2: 1050.85,
    y2: 306.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1070.65,
    y1: 316.35,
    x2: 1089.36,
    y2: 325.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 983.72,
    y: 227.84,
    width: 12.58,
    height: 12.58,
    transform: "translate(212.72 -422.19) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1002.8,
    y: 237.5,
    width: 12.58,
    height: 12.58,
    transform: "translate(219.15 -429.77) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1101.7 283.67 1025.39 245 1019.71 256.22 1096.01 294.89 1107.23 300.57 1112.92 289.35 1101.7 283.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1117.25,
    y: 295.5,
    width: 12.58,
    height: 12.58,
    transform: "translate(257.72 -475.24) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1136.33,
    y: 305.16,
    width: 12.58,
    height: 12.58,
    transform: "translate(264.15 -482.82) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1015.04 218.13 995.96 208.47 990.27 219.69 1009.35 229.35 1020.57 235.04 1026.26 223.82 1015.04 218.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1030.59,
    y: 229.96,
    width: 12.58,
    height: 12.58,
    transform: "translate(218.74 -443.15) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1049.67,
    y: 239.63,
    width: 12.58,
    height: 12.58,
    transform: "translate(225.17 -450.73) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1068.74,
    y: 249.29,
    width: 12.58,
    height: 12.58,
    transform: "translate(231.6 -458.3) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1125.97,
    y: 278.29,
    width: 12.58,
    height: 12.58,
    transform: "translate(250.88 -481.04) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1145.05,
    y: 287.96,
    width: 12.58,
    height: 12.58,
    transform: "translate(257.31 -488.62) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1167.65 295.46 1161.96 306.68 1153.24 323.89 1164.46 329.57 1173.18 312.37 1178.87 301.14 1167.65 295.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1001.16,
    y: 193.42,
    width: 12.58,
    height: 12.58,
    transform: "translate(199.05 -433.79) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1020.23,
    y: 203.09,
    width: 12.58,
    height: 12.58,
    transform: "translate(205.48 -441.37) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1039.31,
    y: 212.76,
    width: 12.58,
    height: 12.58,
    transform: "translate(211.9 -448.95) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1058.39,
    y: 222.42,
    width: 12.58,
    height: 12.58,
    transform: "translate(218.33 -456.52) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1077.46,
    y: 232.09,
    width: 12.58,
    height: 12.58,
    transform: "translate(224.76 -464.1) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.54,
    y: 241.75,
    width: 12.58,
    height: 12.58,
    transform: "translate(231.19 -471.68) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1119.14 249.26 1110.42 266.46 1102.56 262.48 1091.34 256.8 1085.66 268.02 1096.88 273.7 1104.73 277.68 1115.95 283.37 1121.64 272.15 1130.36 254.94 1119.14 249.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1134.69,
    y: 261.08,
    width: 12.58,
    height: 12.58,
    transform: "translate(244.05 -486.84) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1153.77,
    y: 270.75,
    width: 12.58,
    height: 12.58,
    transform: "translate(250.48 -494.42) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1172.84,
    y: 280.42,
    width: 12.58,
    height: 12.58,
    transform: "translate(256.9 -501.99) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1032.47 183.72 1013.4 174.05 1007.71 185.28 1026.79 194.94 1038.01 200.63 1043.69 189.41 1032.47 183.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1048.03,
    y: 195.55,
    width: 12.58,
    height: 12.58,
    transform: "translate(205.07 -454.74) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1067.1,
    y: 205.22,
    width: 12.58,
    height: 12.58,
    transform: "translate(211.5 -462.32) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1086.18,
    y: 214.88,
    width: 12.58,
    height: 12.58,
    transform: "translate(217.93 -469.9) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1105.26,
    y: 224.55,
    width: 12.58,
    height: 12.58,
    transform: "translate(224.35 -477.48) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1124.33,
    y: 234.21,
    width: 12.58,
    height: 12.58,
    transform: "translate(230.78 -485.06) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1143.41,
    y: 243.88,
    width: 12.58,
    height: 12.58,
    transform: "translate(237.21 -492.64) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1162.48,
    y: 253.54,
    width: 12.58,
    height: 12.58,
    transform: "translate(243.64 -500.21) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1181.56,
    y: 263.21,
    width: 12.58,
    height: 12.58,
    transform: "translate(250.07 -507.79) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1018.59,
    y: 159.01,
    width: 12.58,
    height: 12.58,
    transform: "translate(185.38 -445.38) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1037.67,
    y: 168.68,
    width: 12.58,
    height: 12.58,
    transform: "translate(191.8 -452.96) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1056.75,
    y: 178.34,
    width: 12.58,
    height: 12.58,
    transform: "translate(198.23 -460.54) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1075.82,
    y: 188.01,
    width: 12.58,
    height: 12.58,
    transform: "translate(204.66 -468.12) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1094.9,
    y: 197.68,
    width: 12.58,
    height: 12.58,
    transform: "translate(211.09 -475.7) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1113.97,
    y: 207.34,
    width: 12.58,
    height: 12.58,
    transform: "translate(217.52 -483.28) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1133.05,
    y: 217.01,
    width: 12.58,
    height: 12.58,
    transform: "translate(223.95 -490.86) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1152.13,
    y: 226.67,
    width: 12.58,
    height: 12.58,
    transform: "translate(230.38 -498.43) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1171.2,
    y: 236.34,
    width: 12.58,
    height: 12.58,
    transform: "translate(236.8 -506.01) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1190.28,
    y: 246,
    width: 12.58,
    height: 12.58,
    transform: "translate(243.23 -513.59) rotate(26.87)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M813.11,49.27l-5.07,3.46,86.27-28.93c-1.08-.72-2.47-.94-3.78-.5l-77.43,25.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 812.37,
    y: 35.7,
    width: 73.35,
    height: 12.26,
    transform: "translate(30.75 272.09) rotate(-18.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883.43,21.7h8.56c3.38,0,6.13,2.75,6.13,6.13h0c0,3.38-2.75,6.13-6.13,6.13h-8.56v-12.26h0Z",
    transform: "translate(37.37 284.64) rotate(-18.54)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "793.77 60.36 816.22 59.3 812.32 47.67 793.77 60.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.36,
    y1: 53.12,
    x2: 806.59,
    y2: 59.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 757.28,
    y: 72.85,
    width: 174.47,
    height: 97.15,
    transform: "translate(5.21 274.79) rotate(-18.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 772.49,
    y: 84.99,
    width: 159.18,
    height: 81.06,
    transform: "translate(4.3 277.4) rotate(-18.54)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.05,
    y1: 93.82,
    x2: 804.93,
    y2: 185.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 897.66,
    y1: 52.38,
    x2: 928.54,
    y2: 144.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 777.29,
    y1: 103.48,
    x2: 900.9,
    y2: 62.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 801.7,
    y1: 176.28,
    x2: 925.31,
    y2: 134.83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 816.46,
    y1: 154.47,
    x2: 796.62,
    y2: 161.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 811.71,
    y1: 140.31,
    x2: 791.87,
    y2: 146.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.96,
    y1: 126.14,
    x2: 787.12,
    y2: 132.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 802.21,
    y1: 111.98,
    x2: 782.37,
    y2: 118.63
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 775.93,
    cy: 144.43,
    r: 7.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 926.99,
    y: 82.46,
    width: 9.02,
    height: 19.6,
    transform: "translate(19 300.93) rotate(-18.54)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 425.5,
    y: 554.4,
    width: 101.02,
    height: 138.23,
    transform: "translate(-251.61 330.38) rotate(-30.7)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 432.09,
    y: 592.17,
    width: 21.46,
    height: 21.46,
    transform: "translate(-245.73 310.55) rotate(-30.7)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.26,
    y1: 632.7,
    x2: 497.53,
    y2: 603.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.86,
    y1: 643.81,
    x2: 504.12,
    y2: 614.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 461.45,
    y1: 654.91,
    x2: 510.71,
    y2: 625.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.04,
    y1: 666.01,
    x2: 517.3,
    y2: 636.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.63,
    y1: 677.12,
    x2: 523.89,
    y2: 647.87
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1105.64,
    y: 482.24,
    width: 118.07,
    height: 142.71,
    transform: "translate(375.97 -466.64) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1097.9,
    y: 471.15,
    width: 118.07,
    height: 157.05,
    transform: "translate(373.37 -463.57) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1074.92,
    y: 495.79,
    width: 153.32,
    height: 102.33,
    transform: "translate(143.18 1326.98) rotate(-63.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1153.49,
    y: 545.69,
    width: 60.88,
    height: 27.09,
    transform: "translate(380.6 -474.73) rotate(26.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1225.92 520.33 1219.11 511.78 1208.18 511.35 1219.5 489.02 1237.23 498 1225.92 520.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1103.41,
    y: 448.11,
    width: 16.12,
    height: 157.05,
    transform: "translate(358.04 -445.51) rotate(26.87)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 358.86,
    y: 497.63,
    width: 14.08,
    height: 78.62,
    transform: "translate(198.45 -90.87) rotate(19.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.57,484.29h0c2.36,0,4.28,1.92,4.28,4.28v11.73h-8.55v-11.73c0-2.36,1.92-4.28,4.28-4.28Z",
    transform: "translate(184.55 -98.58) rotate(19.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.24,571.7l.94,10.97c.2,2.37,3.11,3.39,4.75,1.67l7.59-7.97-13.29-4.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 348.95,
    y: 555.83,
    width: 14.08,
    height: 18.73,
    transform: "translate(207.24 -85.99) rotate(19.34)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "369.83 504.49 389.76 511.49 378.34 544.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.87 316.7 91.89 365.33 127.3 383.51 134.09 370.3 147.3 377.09 165.49 341.68 116.87 316.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.3 383.51 147.3 377.09 134.09 370.3 127.3 383.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112.15,
    y1: 325.9,
    x2: 124.03,
    y2: 332
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.7,
    y1: 336.97,
    x2: 160.77,
    y2: 350.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1225.01,
    cy: 400.83,
    r: 34.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1257.12,388.38c.78,2.01,1.35,4.05,1.73,6.09l8.52-3.3-4.56-11.76-8.52,3.3c1.09,1.77,2.05,3.66,2.83,5.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1225.01,
    cy: 400.83,
    r: 25.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1237.18,414.6c4.41-1.71,8.15-4.66,10.84-8.54,1.05-4.61,.71-9.36-1-13.77-4.7-12.14-18.4-18.18-30.54-13.48-4.41,1.71-8.15,4.66-10.84,8.54-1.05,4.61-.71,9.36,1,13.77,4.7,12.14,18.4,18.18,30.54,13.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.67e77f15a491d24eee716c32c7ea8d7c.svg";
export { ForwardRef as ReactComponent };